<form autocomplete="off" [name]="formName" [id]="formName" [formGroup]="formControl">
    <shared-forms-input inputSize="xlg" [inputCenter]="false" [showHint]="false" [compact]="compact"
        [parentForm]="formControl" name="voucherCode" [label]="labelAddVoucher" type="text"
        [placeholder]="placeholderAddVoucher" class="voucher-code">
    </shared-forms-input>
    <shared-hint-with-indicator *ngIf="(isError$ | async)" [hintsSize]="'sm'"
                                [hintsFeel]="'danger'" [hintsVSide]="'bottom'" [hintsHSide]="'right'"
                                [messages]="(errorMessage$ | async)" class="form__errors">
    </shared-hint-with-indicator>
</form>
